module.exports = __webpack_public_path__ + "static/img/8.6c18390.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/zh/8.png
// module id = TJvf
// module chunks = 0